







































































































































































































import Vue, { PropOptions } from 'vue';

import SCard from '@stratumfive/ui-baseplate/src/components/SCard/SCard.vue';
import SInputDate from '@stratumfive/ui-baseplate/src/components/SInputDate/SInputDate.vue';
import SInputText from '@stratumfive/ui-baseplate/src/components/SInputText/SInputText.vue';
import SInputSelect from '@stratumfive/ui-baseplate/src/components/SInputSelect/SInputSelect.vue';
import SButton from '@stratumfive/ui-baseplate/src/components/SButton/SButton.vue';
import SAlert from '@stratumfive/ui-baseplate/src/components/SAlert/SAlert.vue';
import SDialog from '@stratumfive/ui-baseplate/src/components/SDialog/SDialog.vue';

import moment from 'moment';
import EventBus from '../../EventsBus';
import GMTOffsetValues from '../../data/gmt-offset-values';
import VersionSelect from './VersionSelect.vue';
import { SubmissionVersion, ExistingSubmission } from '../types/FormDefinition';

/**
 * This component will display on every submission before
 * allowing the user to enter form content.
 */
export default Vue.extend({
  name: 'SubmissionInformation',
  components: {
    SCard,
    SInputDate,
    SInputText,
    SInputSelect,
    SButton,
    SAlert,
    VersionSelect,
    SDialog,
  },
  inject: ['currentVersion', 'latestVersion', 'editable'],
  props: {
    versions: {
      type: Array,
      required: false,
      default: (): SubmissionVersion[] => [],
    } as PropOptions <SubmissionVersion[]>,
    description: {
      type: String,
      required: false,
    },
    status: {
      type: String,
      required: false,
    },
    canEdit: {
      type: Boolean,
      required: false,
      default: false,
    },
    existingMeta: {
      type: Object,
      required: false,
      default: (): any => ({
        date: '',
        time: '',
        offset: '',
      }),
    },
    /**
     * Whether we should allow a timestamp to be selected that already existings
     * in a previous report
     */
    allowDuplicateTimestamps: {
      type: Boolean,
      required: false,
      default: true,
    },

    /**
     * Previous submissions. These are used to test for duplicate timestamps if the
     * allowDupicateTimestamps prop is true
     */
    previousSubmissions: {
      type: Array,
      required: false,
      default: () => [],
    } as PropOptions<ExistingSubmission[]>,

    deletable: {
      type: Boolean,
      default: false,
    },
  },
  data(): any {
    return {
      metaFields: {
        date: '',
        time: '',
        offset: '',
      },
      offsetValues: GMTOffsetValues,
      formIsValid: false,
      editMode: true,
      metaHasBeenSet: false,
      showDeleteWarning: false,
    };
  },
  computed: {
    /**
     * The version of the current selected form.
     */
    currentVersionNumber(): number {
      return this.currentVersion().version;
    },
    /**
     * The latest version number from the global formDef.
     */
    latestVersionNumber(): number {
      return this.latestVersion().version;
    },
    /**
     * Check to see if we are on the latest version. If not, we shouldn't be able to
     * edit the form.
     */
    isLatestVersion(): boolean {
      return this.currentVersionNumber === this.latestVersionNumber;
    },
    /**
     * Whether or not the actual submission itself is editable.
     */
    submissionIsEditable(): boolean {
      return this.editable();
    },

    /**
     * Use the submission globals to an array of unique dates representing the report dates of the
     * other submissions we have locally
     */
    reportDates(): moment.Moment[] {
      return [
        ...new Set([
          ...this.previousSubmissions.map((submission) => moment(submission.reportDate)),
        ]),
      ];
    },

    /**
     * Whether the chosen report date is unique.
     */
    dateIsUnique(): boolean {
      // If the allow duplicate timestamps prop is true we should always return
      // true here because it doesn't matter if the date isn't unique
      if (this.allowDuplicateTimestamps) {
        return true;
      }

      const parsedDate = moment.parseZone(
        `${this.metaFields.date} ${this.metaFields.time} ${this.metaFields.offset}`,
        'YYYY-MM-DD HH:mm Z',
      );

      const matchedDate = this.reportDates.find((date) => parsedDate.isSame(date));
      return !matchedDate;
    },
  },
  watch: {
    currentVersionNumber(version: number): void {
      this.editMode = (version === this.latestVersionNumber);
    },
  },
  created(): void {
    if (this.existingMeta) {
      this.metaFields = {
        date: this.existingMeta.date,
        time: this.existingMeta.time,
        offset: this.existingMeta.offset,
      };
      this.metaHasBeenSet = true;
      this.editMode = false;
    } else {
      let date = moment();
      const urlParams = new URLSearchParams(window.location.search);
      if (urlParams.get('date')) {
        const urlDate = urlParams.get('date');
        date = moment(urlDate!);
      }

      this.metaFields = {
        date: date.format(),
        time: date.format('HH:mm'),
        // offset is null instead of '00:00' to force the user to choose
        // from a blank dropdown-selector defaulting to hint text.
        offset: null,
      };
    }

    EventBus.$on('versionChanged', this.handleVersionChanged);
    EventBus.$on('formDateUpdated', this.handleFormDateUpdated);
  },

  methods: {
    /**
     * Update the form class with our new date values.
     */
    handleMetaSubmit(): void {
      const dateOnly = this.metaFields.date.split('T')[0];
      this.metaFields.date = dateOnly;
      this.$emit('formMetaUpdated', this.metaFields);
      this.editMode = false;
      this.metaHasBeenSet = true;
    },
    /**
     * Update our local values if the form date changes.
     */
    handleFormDateUpdated(payload) {
      Object.assign(this.metaFields, payload);
    },
    /**
     * When the version is changed, reset the meta part of the form.
     */
    handleVersionChanged(payload) {
      if (payload.version === this.latestVersionNumber) {
        this.editMode = true;
        this.metaHasBeenSet = false;
      }
    },
    handleDeleteClick() {
      this.showDeleteWarning = false;
      this.$emit('deleteSubmission');
    },
  },
});
